import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "type"]

import { PropType } from 'vue';
import { MimeType } from '@/globals/helpers/media/mimeTypeUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
  thumbnail: { type: String, default: (() => undefined) },
  source: { type: String, required: true },
  type: { type: String as PropType<MimeType> },
  showThumb: { type: Boolean, default: true },
},
  setup(__props) {



const audio = new Audio();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showThumb)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          "data-dropable": "true",
          src: __props.thumbnail
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("audio", {
      controls: "",
      src: __props.source,
      type: __props.type
    }, null, 8, _hoisted_3)
  ]))
}
}

})